import { PHONE_TYPE_FAX } from '../constants';

export default function phoneCanReceiveOralCommunication(phoneType = '') {
  return phoneType !== PHONE_TYPE_FAX;
}
